<template>
    <div id="participant-list">
        <div id="alone" :class="{ 'table': isAlone, 'd-none': !isAlone }">
            <p class="text-center text-monospace h3 font-weight-bold" style="display: table-cell; color: whitesmoke">
                {{ isFull ? "Room is already full. You cannot join!" : "No User Connected" }} <i class="far fa-frown"></i>
            </p>
        </div>
        <div :class="{ 'd-none': isAlone }">
            <div class="row m-0">
                <div class="col-12">
                </div>
                <div id="listData" class="part-list" ref="listRef">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed, watch, toRaw } from "vue";
import CommonService from "@/service/crmservice/commonService";
import VideoChatService from "@/service/crmservice/videochat.service";
import { videoChatStore } from '@/store/videochat'
export default {
    name: "Participants",
    components: {

    },
    props: {
        activeRoom: String,
        isFull: Boolean,
        userName: String,
        isOwner: Boolean,
        activeRoomName: String
    },
    setup(props, ctx) {

        const commonService = ref(new CommonService());
        const videoChatService = ref(new VideoChatService());
        const leaveRoom = ref('');
        const participantsChanged = ref("");
        const isRoomActive = ref(true);
        const _participantCount = ref(0);
        const participants = ref("");
        const dominantSpeaker = ref("");
        const listRef = ref("");
        const videoStore = videoChatStore();


        const participantCount = computed({

            // getter
            get() {
                return _participantCount.value;
            },
            // setter
            set(newValue) {
                // Note: we are using destructuring assignment syntax here.
                [_participantCount.value] = newValue
            }
        })

        watch(participantCount, (newValue) => {

        })


        watch(listRef, (newValue) => {
            // this callback is invoked when myRef changes
            listRef.value = newValue;
        })

        const isAlone = computed({
            // getter
            get() {
                return (participants.value != null ? participants.value.size : 0) == 0;
            },
            // setter
            set(newValue) {
                // Note: we are using destructuring assignment syntax here.
                [participants.value] = newValue
            }
        })

        watch(isAlone, async (newValue) => {

            //isAlone = newValue
        })

        const clear = () => {
            if (participants.value) {
                participants.value.clear();
            }
        }
        const getParticipantsCount = () => {
            return participantCount.value;
        }
        const initialize = (participantss) => {
            participants.value = participantss;
            _participantCount.value = !!participants.value ? participants.value.size : 0;
            if (participants.value) {
                participants.value.forEach(participant => registerParticipantEvents(participant));
            }
        }

        const add = (participant) => {
            if (participants.value && participant) {
                isAlone.value = participants.value;
                registerParticipantEvents(participant);
                _participantCount.value = !!participants.value ? participants.value.size : 0;
            }
        }

        const remove = (participant) => {
            if (participants.value) {
                participant.tracks.clear();
                console.log("participants.value",participants.value)
                // let removep = toRaw(participants.value);
                // removep.delete(participant.sid);
                // participants.value = removep;
                _participantCount.value = !!participants.value ? participants.value.size : 0;
            }
        }

        const loudest = (participant) => {
            dominantSpeaker.value = participant;
        }

        const onLeaveRoom = (event) => {

            leaveRoom.value.emit(true);
        }

        const registerParticipantEvents = (participant) => {
            if (participant) {
                let participants = toRaw(participant);
                participants.tracks.forEach(publication => subscribe(publication, participant));
                participants.on('trackPublished', publication => subscribe(publication, participant));
                participants.on('trackUnpublished',
                    publication => {
                        if (publication && publication.track) {
                            detachRemoteTrack(publication.track, participant);
                        }
                    });
            }
        }

        const subscribe = (publication, participant) => {
            if (publication && publication.on) {
                console.log("publication", publication);
                console.log("publication.on", publication.on);
                publication.on('subscribed', (track) => attachRemoteTrack(track, participant));
                publication.on('unsubscribed', (track) => detachRemoteTrack(track, participant));
            }
        }

        const attachRemoteTrack = (track, participant) => {
         
            if (isAttachable(track)) {
                const element = track.attach();

                const dynamicElement = document.createElement('div');
                dynamicElement.classList.add('video-container');

                if (track.kind == 'video') {
                    console.log("dynamicElement", dynamicElement)
                    element.setAttribute("id", track.name);
                    element.classList.add('video-component');
                    element.style.objectFit = 'fill'
                    dynamicElement.appendChild(element)
                }

                let participants = toRaw(participant)

                //================================================= Audio Track Callback ==============================================================//

                if (track.kind == 'audio') {

                    //============================ Disable Audio ==============================//

                    track.on('disabled', (event) => {

                        if (participants.state == "connected" && participants.videoTracks != null) {
                            participants.videoTracks.forEach((element) => {                              
                                let updateData = document.getElementById(element.trackSid)
                                updateData.innerHTML = 'Mute'
                            })
                        }
                    })


                    //============================ Enable Audio ==============================//

                    track.on('enabled', (event) => {

                        if (participants.state == "connected" && participants.videoTracks != null) {
                            participants.videoTracks.forEach((element) => {                              
                                let updateData = document.getElementById(element.trackSid)                             
                                updateData.innerHTML = 'Unmute'
                            })
                        }
                    })
                }




                if (track.kind == 'video') {

                    if (participants.state == "connected" && participants.videoTracks != null) {
                        const text = document.createTextNode(participants.identity);
                        const d2 = document.createElement('h4');
                        d2.style.color = "white"
                        d2.appendChild(text);
                        dynamicElement.appendChild(d2)

                        //===== Add Mute/unmute =========

                        console.log("participants-Add", participants)

                        if (participants.state == "connected" && participants.audioTracks != null) {

                            participants.audioTracks.forEach((element) => {

                                const MuteButton = () => {
                                    if (element.track) {
                                        if (!element.track.isEnabled) {
                                            const btn = document.createElement("BUTTON");
                                            btn.setAttribute("id", track.sid);
                                            const text = document.createTextNode("Mute");
                                            btn.setAttribute("style", "color:blue;font-size:23px");
                                            btn.appendChild(text);
                                            dynamicElement.appendChild(btn)

                                        } else {
                                            const btn = document.createElement("BUTTON");
                                            btn.setAttribute("id", track.sid);
                                            const text = document.createTextNode("Unmute");
                                            btn.setAttribute("style", "color:blue;font-size:23px");
                                            btn.appendChild(text);
                                            dynamicElement.appendChild(btn)
                                        }
                                    }
                                }

                                setTimeout(MuteButton, 3000);
                            })
                        }
                    }

                    listRef.value.appendChild(dynamicElement)


                    //================================================= Video Track Callback ==============================================================//

                    track.on('enabled', (event) => {

                        if (isAttachable(event)) {
                            if (event) {                             
                                let updateData = document.getElementById(event.name);                            
                                const elementData = event.attach();
                                elementData.setAttribute("id", event.name);
                                elementData.style.objectFit = 'fill';                 
                                updateData.parentNode.replaceChild(elementData, updateData);
                            }
                        }                     
                    });

                    track.on('disabled', (event) => {
                     
                        if (isAttachable(event)) {
                            if (event) {
                                console.log("event", event);
                                let updateData = document.getElementById(event.name);
                                console.log("updateData", updateData);
                                const elementData = event.attach();
                                elementData.setAttribute("id", event.name);
                                elementData.style.objectFit = 'fill';
                                elementData.style.border = '3px solid red';
                                elementData.style.background = 'black';
                                elementData.style.height = '445px';
                                elementData.style.width = '662px';
                                elementData.style.marginTop = '30px';
                                elementData.style.marginBottom = '30px';
                                elementData.style.display = 'flex'
                                elementData.style.alignItems = 'center';
                                elementData.style.justifyContent = 'center';                              
                                updateData.parentNode.replaceChild(elementData, updateData);
                            }
                        }

                    });
                } else {

                }
                ctx.emit('participantsChanged', true)
            }
        }


        const detachRemoteTrack = (track, participant) => {
            console.log("detachRemoteTrack", track)
            if (isDetachable(track)) {
                track.detach().forEach(el => {
                    if (el.tagName.toLowerCase() == 'video')
                        el.parentElement.remove()
                    else
                        el.remove()
                });
                ctx.emit('participantsChanged', true)
            }
        }

        const isAttachable = (track) => {
            return !!track &&
                ((track).attach !== undefined ||
                    (track).attach !== undefined);
        }

        const isDetachable = (track) => {
            return !!track &&
                ((track).detach !== undefined ||
                    (track).detach !== undefined);
        }
        //====================== onMounted ===========================

        onMounted(() => {
            const result = videoStore.IsCallEnded
            if (!result) {
                isRoomActive.value = result;
            } else {
                isAlone.value = participants.value;
            }
        });

        //====================== return ===========================

        return {
            leaveRoom,
            participantsChanged,
            isRoomActive,
            _participantCount,
            isAlone,
            participantCount,
            dominantSpeaker,
            participants,
            listRef,
            isDetachable,
            isAttachable,
            detachRemoteTrack,
            attachRemoteTrack,
            subscribe,
            registerParticipantEvents,
            loudest,
            onLeaveRoom,
            remove,
            add,
            initialize,
            getParticipantsCount,
            clear
        }
    },
}
</script>


<style scoped>
:host,
#participant-list {
    width: 100% !important;
    height: 100% !important;
}

#participant-list {
    border: solid 6px rgb(34, 34, 34);
    background-color: rgb(38, 38, 38);
}

#alone {
    height: 100%;
    min-height: 400px;
}

#alone.table {
    display: table;
}

div>p {
    vertical-align: middle;
    display: table-cell;
    padding: 0 10%;
}

.leave-room {
    background-color: #F22F46;
}

.navbar.shadow {
    border-bottom: solid 3px rgb(34, 34, 34) !important;
}


.part-list .app-camera {
    width: 100%;
    display: inline-block;
    max-width: 50%;
}

.part-list .app-camera~video {
    max-width: 50%;
    margin: 5 !important;
    display: inline-block;
    border: 1px solid #fff
}

.part-list #participant-list {
    border: none;
    background-color: #fff;
}

.part-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
}

.part-list .video-container {
    display: flex;
    width: 33.3%;
    max-height: 285px !important;
    padding: 5px;
    position: relative;
}

.video-container {
    display: flex;
    width: 33.3%;
    max-height: 285px !important;
    padding: 5px;
    position: relative;
}

.video-component {
    width: 100% !important;
    max-height: 275px !important;
}

h4.video-title {
    position: absolute;
    bottom: 0;
    padding: 10px 15px;
    background: #2f40509e;
    width: calc(100% - 10px);
    left: 5px;
}

@media only screen and (max-width: 768px) {
    .part-list .video-container {
        width: 50%;
    }

    h4.video-title {
        font-size: 14px;
    }
}
</style>